import classNames from "classnames";
import Link from "next/link";
import React from "react";
import { imageSizerString } from "lib/fun";
import { getArticlePath } from "common";

import { ArticleSubHeader } from "./ArticleSubHeader";
import styles from "./RankedArticles.module.scss";
import { ArticleItemFragment } from "../../generated/graphql";

interface Props {
  rankedArticles: Array<ArticleItemFragment>;
}

export const RankedArticles = ({ rankedArticles }: Props) => {
  return rankedArticles.length ? (
    <div>
      <ArticleSubHeader label="Ranking articles" subLabel="記事ランキング" />
      <div>
        {rankedArticles.map((article, index) => (
          <div
            key={article.id}
            className={classNames(styles.article, styles.rankedArticles)}
          >
            <div className={styles.articleIndex}>{index + 1}</div>
            <Link href={getArticlePath(String(article.id))}>
              <a>
                <div className={styles.articleImg}>
                  <img
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    src={`${imageSizerString(article.imageUrl!, 500, 250)}`}
                  />
                </div>
                <div className={styles.articleLink}>{article.title}</div>
                <div className={styles.articleCategory}>
                  {article.category.name}
                </div>
              </a>
            </Link>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};
